module.exports = __webpack_public_path__ + "media/LandingPageAssets/fbicon-794c1b81.svg";